import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import base from '../../apis';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import NotificationModal from '../../components/NotificationModal/NotificationModal';
import Spinner from '../../components/Spinner/Spinner';
import { Select } from '@mantine/core';
import './addmarketingexec.scss';
import { marketerOptions } from '../../constants';

function AddMarketingExec() {
  const [toastOpen, setToastOpen] = useState(false);
  const navigate = useNavigate();
  const { type } = useParams();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    address: '',
    phone: '',
    corporate_id: '',
    category: 'us_agent',
    hiring_date: new Date().toISOString().split('T')[0],
  });

  const [isLoading, setIsLoading] = useState(false);
  const title = type === 'snr-mark-execs' ? 'Senior Market Executive' : 'Market Executive';

  const createUser = (again) => {
    const urlToCall = type === 'snr-mark-execs' ? '/operations/snr_marketers/' : '/operations/marketers/';
    const { first_name, last_name, email, address, phone, hiring_date, category } = formData;
    setIsLoading(true);

    const body = {
      phone,
      address,
      hiring_date,
      user: {
        email,
        first_name,
        last_name,
        password: 'qwertyuu1&11',
        role: type === 'snr-mark-execs' ? 'snr_marketer' : 'marketer',
      },
    };
    if (type !== 'snr-mark-execs') {
      body.category = category;
    }

    base
      .post(urlToCall, body)
      .then((res) => {
        setIsLoading(false);
        setToastOpen(true);
        setTimeout(() => {
          setToastOpen(false);
          if (!again) {
            navigate(-1);
          } else {
            setFormData({
              first_name: '',
              last_name: '',
              email: '',
              address: '',
              phone: '',
              corporate_id: '',
              hiring_date: new Date().toISOString().split('T')[0],
            });
          }
        }, 500);
      })
      .catch((err) => {
        const emailError = err?.response?.data?.user?.email?.[0];
        setIsLoading(false);
        toast.error(emailError || `Error Creating ${title}`);
      });
  };

  //todo add email validation
  const onSave = (again) => {
    //validate data and send
    //THEN add successful message
    if (
      formData.first_name === '' ||
      formData.last_name === '' ||
      formData.email === '' ||
      formData.address === '' ||
      formData.phone === '' ||
      // formData.corporate_id === '' ||
      formData.hiring_date === '' ||
      (type !== 'snr-mark-execs' && formData.category === '')
    ) {
      toast.warn(`Please fill all fields`);
      return;
    }
    createUser(again);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      {isLoading && <Spinner />}
      <NotificationModal
        Style={{ maxWidth: 'fit-content' }}
        isOpen={toastOpen}
        message="Marketing Executive Agent has been added successfully"
      />
      <form className="adexec" onSubmit={(e) => e.preventDefault()}>
        <p>Add New {title}</p>
        <div className="divider">
          <Input
            label="First Name"
            placeholder="First Name"
            autoFocus
            required
            name="first_name"
            onChange={onChange}
            value={formData.first_name}
          />
          <Input
            label="Last Name"
            placeholder="Last Name"
            required
            name="last_name"
            onChange={onChange}
            value={formData.last_name}
          />
        </div>
        <Input
          label="Address"
          placeholder="Address"
          required
          name="address"
          onChange={onChange}
          value={formData.address}
        />
        <div className="divider">
          <Input
            label="Day of Hiring"
            placeholder="Day of Hiring"
            type="date"
            required
            name="hiring_date"
            value={formData.hiring_date}
            onChange={onChange}
          />
          <Input
            label="Phone"
            placeholder="Phone"
            type="tel"
            required
            name="phone"
            onChange={onChange}
            value={formData.phone}
          />
          {type !== 'snr-mark-execs' && (
            <Select
              label="Choose marketer type"
              data={marketerOptions}
              size="md"
              mt="md"
              placeholder="Select marketer type"
              name="category"
              value={formData.category}
              onChange={(value) => setFormData((prevState) => ({ ...prevState, category: value }))}
            />
          )}
        </div>
        <div className="divider">
          <Input
            label="Email Address"
            placeholder="Email Address"
            type="email"
            required
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            name="email"
            onChange={onChange}
            value={formData.email}
          />
          {/* <Input
						label='Corporate ID'
						placeholder='Corporate ID'
						style={{ marginRight: '10px' }}
						fullStyles={{ width: '50%' }}
						required
						name='corporate_id'
						onChange={onChange}
						value={formData.corporate_id}
					/> */}
        </div>

        <div className="butHolder">
          <Button
            style={{
              width: '200px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            type="submit"
            text="Save"
            onClick={() => onSave(false)}
          />
          <Button
            style={{
              width: '200px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            onClick={() => onSave(true)}
            type="submit"
            text="Save & Add Another"
          />
          <Button
            style={{
              width: '200px',
              fontSize: '16px',
              padding: '10px',
              backgroundColor: 'white',
              color: 'var(--primary-color)',
              display: 'block',
            }}
            onClick={() => navigate(-1)}
            type="reset"
            text="Cancel"
          />
        </div>
      </form>
    </>
  );
}

export default AddMarketingExec;
